"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePlaceholderHints = void 0;
var _react = require("react");
var _sharedFunctions = require("../sharedFunctions");
const usePlaceholderHints = ({
  hintsConfig,
  id
}) => {
  const timeoutRef = (0, _react.useRef)();
  const {
    phrases = ['Find your favorite domain'],
    writeDelay = 75,
    deleteDelay = 30,
    beforeWriteDelay = 100,
    beforeDeleteDelay = 1000
  } = hintsConfig || {};
  const inputNode = (0, _sharedFunctions.isBrowser)() ? document.getElementById(id) : null;

  // eslint-disable-next-line max-statements
  const run = (current, next, timeout, isDeleting) => {
    if (!isDeleting) {
      if (!next.length) {
        isDeleting = true;
        timeout = beforeDeleteDelay;
      } else {
        timeout = writeDelay;
        current.push(next.shift());
      }
    } else if (isDeleting) {
      if (!current.length) {
        let nextIndex = phrases.findIndex(item => item.includes(next.join(''))) + 1;
        if (nextIndex >= phrases.length) {
          nextIndex = 0;
        }
        isDeleting = false;
        timeout = beforeWriteDelay;
        next = phrases[nextIndex].split('');
      } else {
        timeout = deleteDelay;
        next.unshift(current.pop());
      }
    }
    timeoutRef.current = setTimeout(() => {
      if (inputNode) {
        inputNode.placeholder = current.join('');
      }
      run(current, next, timeout, isDeleting);
    }, timeout);
  };
  const runHints = () => {
    clearTimeout(timeoutRef?.current);
    run([], phrases[0].split(''), 0, false);
  };
  const hideHints = text => {
    clearTimeout(timeoutRef?.current);
    if (inputNode) {
      inputNode.placeholder = text || '';
    }
  };
  return {
    runHints,
    hideHints
  };
};
exports.usePlaceholderHints = usePlaceholderHints;